module.exports = __webpack_public_path__ + "static/media/KR.f19f5881.png";